import { render, staticRenderFns } from "./JcdcCommentModal.vue?vue&type=template&id=2033bc6d&scoped=true"
import script from "./JcdcCommentModal.vue?vue&type=script&lang=ts"
export * from "./JcdcCommentModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2033bc6d",
  null
  
)

export default component.exports